module.exports = "../static/images/dab39d.png";